<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>일관성 체크</span>
                        <h1>글에 전문가의 손길을 더하다</h1>
                        <p>클릭 몇 번만 하면 시간을 절약하고 전문적인 글을 완성할 수 있습니다. 트링카의 일관성 체크는 특히 장문의 문서에서 찾기 어려운 비일관적인 부분을 찾아 수정합니다.</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=KR" id="autoEditGetStart" target="_blank">시작하기</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/Consistency-Checks.png" alt="consistency-check">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/ConsistencyCheckThumbnail.png" alt="thumbnail" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>실제 보기</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">이해하기 쉬운 안내 동영상을 통해 일관성 체크를 즉시 시작해 보세요.</p>
                        <p style="margin-bottom: 10px;">트링카를 최대한 활용할 수 있도록 단계별로 상세하게 안내해 드립니다. 더 궁금한 사항이 있으신가요?
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">여기</a>에서 FAQ를 찾아보세요.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>트링카 일관성 체크의 주요 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카는 다양한 비일관적인 부분을 식별하여 글이 전문적으로 보이도록 도와드립니다.
                            <br /> 비일관적인 부분을 식별하여 수정하는 유형은 다음과 같습니다.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards  ">
                        <div class="feature_num">01</div>
                        <h3>띄어쓰기</h3>
                        <p class="fearureCardText">트링카는 동일한 단어에 사용된 다른 철자법
                            <span>(미국식 영어와 영국식 영어)</span> 을 식별합니다.</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="colourSection" name="spellingchecks" checked>
                                <label for="colourSection">colour (4 occurences) </label>
                            </p>
                            <p>
                                <input type="radio" id="colorSections" name="spellingchecks">
                                <label for="colorSections">color (4 occurences) </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards ">
                        <div class="feature_num">02</div>
                        <h3>하이픈과 대시</h3>
                        <p class="fearureCardText">트링카는
                            <span>하이픈과 대시</span> 가 일관되지 않게 사용된 경우를 찾아 클릭 한 번으로 일치시켜 드립니다.</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                <label for="ultra-violet">ultra-violet (5 occurrences)
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="ultra_violet" name="dashesCehcks">
                                <label for="ultra_violet">ultra violet (5 occurrences)
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards ">
                        <div class="feature_num">03</div>
                        <h3>숫자 표기</h3>
                        <p class="fearureCardText">숫자를 표기할 때
                            <span>아라비아 숫자와 문자 표기</span> 를 번갈아 사용하는 것은 가장 일반적인 불일치 사례 중 하나입니다. 트링카는 클릭 한 번으로 이를 피할 수 있도록 도와드립니다.</p>
                        <div class="custom_radioButtons">
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="averagesixyears" name="sadfdashesCehcks" checked>
                                    <label for="averagesixyears">
                                        <b>average six years</b>
                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>
                                        <b>average 6 years</b>
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="average-sixyears" name="sadfdashesCehcks">
                                    <label for="average-sixyears">
                                        <b>average 6 years</b>
                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>
                                        <b>average six years</b>
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="feature_num">04</div>
                        <h3>기호</h3>
                        <p class="fearureCardText">트링카는 사용자가 기호를 표기할 때
                            <span>기호와 문자를 번갈아 사용</span>하면 이를 알아봅니다. </p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFourContent_one" name="exampeFourContent" checked>
                                <label for="exampeFourContent_one">
                                    <b>TNF-alpha"</b>
                                    <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>
                                    <b>tnf-α"</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFourContent_two" name="exampeFourContent">
                                <label for="exampeFourContent_two">
                                    <b>tnf-α"</b>
                                    <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>
                                    <b>TNF-alpha"</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="feature_num">05</div>
                        <h3>띄어쓰기</h3>
                        <p class="fearureCardText">띄어쓰기는 눈에 잘 띄지 않아 놓치기 쉽습니다. 트링카를 사용하면 글 전체에서
                            <span>일관되지 않은 띄어쓰기</span> 를 클릭 몇 번만으로 제거할 수 있습니다. </p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFiveContent_one" name="exampeFiveContent" checked>
                                <label for="exampeFiveContent_one">
                                    <b>p
                                        <0</b>
                                            <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>
                                            <b>p
                                                < 0</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFiveContent_two" name="exampeFiveContent">
                                <label for="exampeFiveContent_two">
                                    <b>p
                                        < 0</b>
                                            <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>
                                            <b>p
                                                <0</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="cloud_key_features toolbox_img_content">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>View a Sample Report</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Dashes</h2>
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                    <label for="ultra-violet">ultra-violet (5 occurrences)
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="ultra_violet" name="dashesCehcks">
                                    <label for="ultra_violet">ultra violet (5 occurrences)
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Spacing</h2>
                            <div class="custom_radioButtons">
                                <p style="margin: 0;">
                                    <input type="radio" id="addSpaicng" name="spacingChecks" checked>
                                    <label for="addSpaicng">Add space</label>
                                </p>
                                <ul style="margin-bottom: 20px;">
                                    <li>p
                                        <0 <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/> p
                                        < 0 </li>
                                            <li>p=0
                                                <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>p = 0 </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Numbers</h2>
                            <div class="custom_radioButtons">
                                <p style="margin: 0;">
                                    <input type="radio" id="spelledOut" name="numberschecks" checked>
                                    <label for="spelledOut">Spelled-out
                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/> Numeral
                                    </label>
                                </p>
                                <ul style="margin-bottom: 20px;">
                                    <li>average six years
                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>average 6 years </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Spelling</h2>
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="colourSection" name="spellingchecks" checked>
                                    <label for="colourSection">colour (4 occurences) </label>
                                </p>
                                <p>
                                    <input type="radio" id="colorSections" name="spellingchecks">
                                    <label for="colorSections">color (4 occurences) </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Greek Letter Style</h2>
                            <div class="custom_radioButtons">
                                <p style="margin: 0;">
                                    <input type="radio" id="GreekSpelledOut" name="Greekletterstyle" checked>
                                    <label for="GreekSpelledOut">Spelled-out
                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/> Symbol
                                    </label>
                                </p>
                                <ul style="margin-bottom: 20px;">
                                    <li>TNF-alpha"
                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>tnf-α"
                                    </li>
                                    <li>"Beta particles
                                        <img src="../../../assets/images/spacingArrow.png" alt="spacing-icon"/>"β particles
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div> -->
    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>글이 일관되고 전문적인지 확인하기</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">시작하기</a>
            </div>
        </div>
    </div>
    <!-- <div class="forpersonlized_sections">
        <p>Experience Advanced Writing Assistance</p>
        <div class="forpersonlizedFooter">
            <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">Get Started</a>
        </div>
    </div> -->
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>자주하는 질문</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        트링카의 일관성 체크는 어떤 식으로 이루어지나요?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>트링카의 일관성 체크는 저자가 실수하는 다양한 일반적 불일치를 그 변형까지 자동으로 찾아내 모두 나열합니다. 뿐만 아니라 수정 옵션도 제공합니다.
                                            적합한 스타일을 선택하고 확인만 해주시면 나머지는 트링카가 처리해 드립니다.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">일관성 체크 기능은 어디에서 찾을 수 있나요?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>현재 모든 사용자가 Cloud 편집기에서 일관성 체크 기능을 사용하실 수 있습니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        일관성 체크 기능을 사용하려면 크레딧이 필요한가요?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>현재로서는 일관성 체크 기능을 사용하는 데 크레딧이 필요하지 않습니다. 원하는 만큼 기능을 사용하실 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        언제 일관성 체크 기능을 사용해야 할까요?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>문서 작성을 마친 후 일관성 체크 기능을 실행하는 것이 가장 이상적입니다. 그러나 필요할 때마다 여러 번 실행할 수도 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        언제 일관성 체크 기능을 사용해야 할까요?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>문서 작성을 마친 후 일관성 체크 기능을 실행하는 것이 가장 이상적입니다. 그러나 필요할 때마다 여러 번 실행할 수도 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>다른 앱에서
                                    <br /> 트링카 사용</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/kr/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                            <h3>클라우드</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser-icon">
                                            <h3>브라우저 플러그인</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">기업</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/hTaMLLHICCo"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>